import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import delivery from "../../assets/delivery.png";
import { Link } from "react-router-dom";
import blogdetailimage from "../../assets/blogdetail.png";

function Card({blog}) {
  console.log("🚀 ~ Card ~ blog:", blog)


  return (
    <>
    <Link to={`/blog/${blog.slug}`} className="h-auto rounded-lg overflow-hidden shadow-lg bg-white flex flex-col">
      {/* Image */}
      <img
        src={blog.image ||blogdetailimage}
        alt={blog.title}
        className="w-full h-[200px] object-cover"
      />

      {/* Content */}
      <div className="p-4 body flex flex-col justify-between flex-grow">
        {/* Date */}
        <p className="md:text-[14.54px] text-[7px] body leading-[28px] text-[#AF313D] font-medium mb-2">
        <p>{new Date(blog.publishedAt).toLocaleString()}</p>

        </p>

        {/* Title with Icon */}
        <Link
            to={`/blog/${blog.slug}`}>
               <div className="flex items-center justify-between">
          <h2 className="md:text-[24.92px] sm:text-[11px] cursor-pointer text-[8.5px] body font-semibold text-gray-900">
            {blog.title}
          </h2>
          <FiArrowUpRight className="text-gray-500 text-lg cursor-pointer" />
        </div> </Link>
       

        {/* Description */}
        <p className="text-[#333333] body md:text-[16.62px] sm:text-[8px] text-[7px] mt-2 overflow-hidden line-clamp-3">
          {blog.excerpt}
        </p>

        {/* Button - aligned to the right */}
        <div className="mt-4 text-right">
        <Link
            to={`/blog/${blog?.slug}`}  // Use dynamic blog id
            className="bg-[#AF313D] md:w-[102px] w-[55px] h-[20px] body md:h-[31.38px] text-white text-[7px] px-4 py-2 md:text-sm font-medium rounded hover:bg-red-700"
          >
            Read More
          </Link>
        </div>
      </div>
    </Link>
    </>
  );
}

export default Card;
